import {useContext, useEffect, useState} from "react";
import {getLocalStorage, setLocalStorage} from "../../helpers/Storage";
import {TextDisplay} from "../common/data-display/TextDisplay";
import {LanguageContext} from "../../config/ContextConfig";
import {makeStyles} from "@mui/styles";
import {Theme} from "@mui/material";
import ResponsiveButtonWithTooltip from "../common/buttons/ResponsiveButtonWithTooltip";


declare global {
    interface Window {
        gtag: any
    }
}

const useStyle = makeStyles( (theme: Theme) => ({
    root: {
        zIndex: 1500,
        width: '100%',
        position: "fixed",
        bottom: 0,
        left: 0,
        padding: 4 + 'px',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 10 + 'px'
    }
}) );

export function CookieBanner() {

        const [ cookieConsent, setCookieConsent ] = useState< boolean | null>( null );
        const [ isLoading, setIsLoading ] = useState( true );
        const language = useContext( LanguageContext );
        const classes = useStyle();

        const cookieName = "cookie_consent";

        useEffect( () => {
            const storedCookieConsent = getLocalStorage( cookieName , null);
            setCookieConsent( storedCookieConsent );
            setIsLoading( false );
        }, [] );

        useEffect( () => {
            if( cookieConsent !== null ) {
                setLocalStorage( cookieName, cookieConsent );
            }

            const newValue: "granted" | "denied" = cookieConsent ? "granted" : "denied";

            if( typeof window !== "undefined" && window.gtag ) {

                window.gtag(
                    "consent",
                    "update",
                    { 'analytics_storage': newValue }
                );
            }

        }, [ cookieConsent ] );


        if( isLoading || cookieConsent !== null ) {
            return null;
        }

        return (
                <div className={ classes.root } style={ { display: ( cookieConsent ) ? 'none' : 'flex' } }>
                    <div style={{ padding: '10px', backgroundColor: '#2d96c1', color: 'white' }}>
                        <div>
                            <TextDisplay textColor="white" style={{ fontSize: '1.25em' }}>
                                { language.cookieBanner.title }
                            </TextDisplay>
                        </div>

                        <div style={{ marginTop: '20px' }}>
                            <TextDisplay textColor="white">
                                { language.cookieBanner.description }
                            </TextDisplay>

                        </div>
                        <div style={{ gap: '20px', marginTop: '30px', justifyContent: 'center', alignItems: 'center' }} className="flex">
                            <ResponsiveButtonWithTooltip
                                tooltip={''}
                                text={ language.cookieBanner.decline }
                                onClick={() => setCookieConsent( false )}
                            />
                           <ResponsiveButtonWithTooltip
                               tooltip={''}
                               text={language.cookieBanner.consent}
                               onClick={() => setCookieConsent( true )}
                           />
                        </div>
                    </div>
                </div>

        );
}